import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setCurrentSearchType } from 'redux/actions'
import selectController from 'redux/selectors/selectController'
import {
  QA_CONTENT,
  LEGISLATION,
  CURRENT_AWARENESS,
  MW_OVERVIEW,
  DOCUMENTS_CONTENT,
  DOCUMENTS_MENU,
  DOCUMENTS_REVIEW,
  LEGISLATION_FOLDERS,
  LEGISLATION_CATEGORIES,
  MW_LIST_DEALS,
  MW_ANALYTICS,
  MW_DEAL_DETAILS,
  MW_DEAL_COMPARE,
  LEGISLATION_REVIEW,
  CURRENT_AWARENESS_REVIEW,
  LEGISLATION_MENU,
  QA_MENU,
  QA_REVIEW,
  DOCUMENTS_ALL,
  SEARCH
} from 'constants/controllers'

// search results pages all share the SEARCH controller, so their type comes
// from the route's :searchType param rather than the controller
export function getSearchTypeForRoute (controller, routeSearchType) {
  switch (controller) {
    case SEARCH:
      return routeSearchType
    case LEGISLATION:
    case LEGISLATION_MENU:
    case LEGISLATION_FOLDERS:
    case LEGISLATION_CATEGORIES:
    case LEGISLATION_REVIEW:
      return 'legislation'
    case CURRENT_AWARENESS:
    case CURRENT_AWARENESS_REVIEW:
      return 'ca'
    case DOCUMENTS_MENU:
    case DOCUMENTS_CONTENT:
    case DOCUMENTS_REVIEW:
    case DOCUMENTS_ALL:
      return 'documents'
    case MW_OVERVIEW:
    case MW_LIST_DEALS:
    case MW_ANALYTICS:
    case MW_DEAL_DETAILS:
    case MW_DEAL_COMPARE:
      return 'dealwatch'
    case QA_MENU:
    case QA_CONTENT:
    case QA_REVIEW:
      return 'qa'
    default:
      return 'qa'
  }
}

export default function useRouteSyncSearchType (routeSearchType) {
  const controller = useSelector(selectController)
  const dispatch = useDispatch()

  useEffect(() => {
    const typeName = getSearchTypeForRoute(controller, routeSearchType)
    if (!typeName) return
    dispatch(setCurrentSearchType(typeName))
  }, [controller, routeSearchType, dispatch])
}
